module.exports = __webpack_public_path__ + "static/media/tic-tac.12f7e4df.png";